import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne';
import NavBar from '../nav_bar/Navbar';
import AllLeadTaskCreate from './AllLeadTaskCreate';

function AllLeadTask() {
    const [searchUi, setSearchUi] = useState(true);
    const [searchData, setSearchData] = useState(null);

    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<AllLeadTaskCreate />}
                menuId={12}
            />
        </DataContext.Provider>
    );
}

export default AllLeadTask